import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { Select } from "antd";

const Queryss = () => {
  const data = [
    {
      Name: "Get Active Employees",
      Database: "HRMS",
      SqlQuery:
        "SELECT EmpId, EmpName, Department FROM Employees WHERE Status = 'Active'",
      QryType: "SELECT",
    },
    {
      Name: "Delete Old Logs",
      Database: "AppDB",
      SqlQuery: "DELETE FROM SystemLogs WHERE CreatedOn < '2025-01-01'",
      QryType: "DELETE",
    },
    {
      Name: "Update Salary",
      Database: "HRMS",
      SqlQuery:
        "UPDATE Employees SET Salary = Salary * 1.10 WHERE Department = 'Sales'",
      QryType: "UPDATE",
    },
    {
      Name: "Fetch Order List",
      Database: "OrderDB",
      SqlQuery:
        "SELECT OrderId, CustomerName, OrderDate, TotalAmount FROM Orders ORDER BY OrderDate DESC",
      QryType: "SELECT",
    },
    {
      Name: "Deactivate User",
      Database: "UserDB",
      SqlQuery: "UPDATE Users SET IsActive = 0 WHERE UserId = 1052",
      QryType: "UPDATE",
    },
    {
      Name: "Clear Temp Data",
      Database: "TempDB",
      SqlQuery: "DELETE FROM TempSessionData WHERE ExpiryDate < GETDATE()",
      QryType: "DELETE",
    },
    {
      Name: "Get Product Stock",
      Database: "InventoryDB",
      SqlQuery:
        "SELECT ProductId, ProductName, AvailableQty FROM Products WHERE AvailableQty > 0",
      QryType: "SELECT",
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.localeCompare(b.Name),
      render: (text) => (
        <span title={text}>
          {text?.length > 25 ? text.substring(0, 25) + "..." : text}
        </span>
      ),
    },

    {
      title: "SqlQuery",
      dataIndex: "SqlQuery",
      sorter: (a, b) => a.SqlQuery.localeCompare(b.SqlQuery),
      render: (text) => (
        <span title={text}>
          {text?.length > 30 ? text.substring(0, 30) + "..." : text}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "QryType",
      sorter: (a, b) => a.QryType.localeCompare(b.QryType),
      render: (type) => {
        let badgeClass = "";

        switch (type) {
          case "SELECT":
            badgeClass = "badge bg-primary";
            break;
          case "UPDATE":
            badgeClass = "badge bg-warning text-dark";
            break;
          case "DELETE":
            badgeClass = "badge bg-danger";
            break;
          default:
            badgeClass = "badge bg-secondary";
        }

        return <span className={badgeClass}>{type}</span>;
      },
    },
    {
      title: "Actions",
      render: () => (
        <div className="action-icon d-inline-flex align-items-center">
          <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#device_detail"
          >
            <i className="ti ti-eye" />
          </Link>

          <Link
            to="#"
            className="p-2 d-flex align-items-center border rounded me-2"
          >
            <i className="ti ti-trash" />
          </Link>

          <Link
            to="/queryExecute"
            className="p-2 d-flex align-items-center border rounded me-2"
          >
            <i className="ti ti-player-play" />
          </Link>
        </div>
      ),
    },
  ];

  const [addForm, setAddForm] = useState({
    Name: "",
    Database: "",
    SqlQuery: "",
    QryType: "",
    SuperId: "",
  });

  const resetAddForm = () => {
    setAddForm({
      Name: "",
      Database: "",
      SqlQuery: "",
      QryType: "",
      SuperId: "",
    });
  };

  const QueryType1 = [
    { value: "Select", label: "Select" },
    { value: "Insert", label: "Insert" },
    { value: "Update", label: "Update" },
    { value: "Delete", label: "Delete" },
  ];

  useEffect(() => {
    const modal = document.getElementById("add_plans");

    const handleClose = () => {
      resetAddForm();
    };

    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleClose);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("hidden.bs.modal", handleClose);
      }
    };
  }, []);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Querys</h4>
                <h6>Manage your Database Querys</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Refresh"
                >
                  <i data-feather="rotate-ccw" className="feather-rotate-ccw" />
                </Link>
              </li>
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                >
                  <i data-feather="chevron-up" className="feather-chevron-up" />
                </Link>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_plans"
                className="btn btn-primary"
              >
                <i className="ti ti-circle-plus me-1"></i>
                Add
              </Link>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <div className="search-set p-4"></div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                <div className="table-responsive">
                  <Table columns={columns} dataSource={data} rowKey="Name" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      {/* view model */}
      <div className="modal fade" id="device_detail">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="text-gray-9 fw-medium">Query Details</h4>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="fw-bold">Name:</label>
                  <p>{"N/A"}</p>
                </div>

                <div className="col-md-3">
                  <label className="fw-bold">Database:</label>
                  <p>{"N/A"}</p>
                </div>

                <div className="col-md-3">
                  <label className="fw-bold">QueryType</label>
                  <p>{"N/A"}</p>
                </div>

                <div className="col-md-12">
                  <label className="fw-bold">SqlQuery</label>
                  <p>{"N/A"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* add model */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add New Query</h4>
              <button
                id="closeModel"
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                {/* Query Name */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Query Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="Name"
                      placeholder="Enter Query Name"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Database <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="w-100"
                      style={{ height: "40px" }}
                      placeholder="Select Database"
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                    />
                  </div>
                </div>

                {/* QryType */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Query Type <span className="text-danger">*</span>
                    </label>

                    <Select
                      className="w-100"
                      style={{ height: "40px" }}
                      options={QueryType1}
                      value={addForm.QryType}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                    />
                  </div>
                </div>

                {/* Sql Query */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      SQL Query <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={4}
                      name="SqlQuery"
                      placeholder="Enter SQL Query"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-light" data-bs-dismiss="modal">
                Cancel
              </button>

              <button className="btn btn-primary">Save Query</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Queryss;
